import AppInitializer from './AppInitializer';

// This component is just going to serve as a wrapper for the Main Application
// Any route independent global thing can be put here
const App = (): JSX.Element => {
  return <AppInitializer />;
};

export default App;
